export const POPIN_EVENT = {
  OPENED: '__pe_opened',
  CLOSED: '__pe_closed',
};
